import { ContentfulModel } from './ContentfulModel';

export class Link extends ContentfulModel {
    private label: string;
    private href: string;

    parseContentfulData(object: any): void {
        this.label = object.label;
        this.href = object.href;
    }

    getLabel(): string {
        return this.label;
    }

    getHref(): string {
        return this.href;
    }

    getType(): string {
        return 'link';
    }
};
